import {
    Box,
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    ModalCloseButton,
    Text,
} from '@chakra-ui/react';
import React from 'react';

export interface InvoiceUnmatchConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    partNumber?: string;
    nexPartNumber?: string;
    onConfirm: () => void;
}

export default function InvoiceUnmatchConfirmModal(props: InvoiceUnmatchConfirmModalProps) {
    const { isOpen, onClose, partNumber, nexPartNumber, onConfirm } = props;
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Unmatch NEX line?</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="sm" color="gray.600">
                        Are you sure you want to unmatch this invoice line item{partNumber ? ` (${partNumber})` : ''} from its NEX line{nexPartNumber ? ` (${nexPartNumber})` : ''}?
                    </Text>
                    <Box mt={3} p={3} bg="orange.50" borderRadius="md" border="1px solid" borderColor="orange.200">
                        <Text fontSize="sm" color="orange.700">
                            This line item will be flagged and added to NEX without a matching NEX line when saved.
                        </Text>
                    </Box>
                </ModalBody>
                <ModalFooter>
                    <Button size="action" variant="outlineGray" mr={3} onClick={onClose}>Cancel</Button>
                    <Button size="action" colorScheme="red" onClick={onConfirm}>Unmatch</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
